// removed by extract-text-webpack-plugin
module.exports = {"root":"root_1e5PV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Select/style.css
// module id = 213
// module chunks = 0